
import { MutationTypes } from "@/store/modules/auth";
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    userButton: Boolean,
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    home() {
      this.$router.push({ name: "Home" });
    },
    settings() {
      this.$router.push({ name: "userSettings" });
    },
    disconnect() {
      this.$store.commit(`auth/${MutationTypes.LOGOUT}`);
      this.$router.push({ name: "Login" });
    },
  },
});
